export const DROPDOWN_MENU_FACTORY_UID = "bootstrap5-dropdown";
